import React from "react"
import { useTranslation } from "react-i18next"

import PFImage from "assets/images/logo-punkfinance.svg"
import PFWImage from "assets/images/logo-punkfinance-white.svg"
import FFImage from "assets/images/logo-freshfinance.png"
import FFWImage from "assets/images/logo-freshfinance-white.png"

import { isFreshFinance } from "helpers/features"
import Image from "components/ui/Image"

type Props = {
  white: boolean
  width?: number
}

const LogoComponent = ({ white, width }: Props) => {
  const { t } = useTranslation()

  const whiteLogo = isFreshFinance() ? FFWImage : PFWImage
  const darkLogo = isFreshFinance() ? FFImage : PFImage

  return (
    <Image
      src={white ? whiteLogo : darkLogo}
      alt={t("menu.logo.title")}
      width={width}
    />
  )
}

LogoComponent.defaultProps = {
  white: false,
  width: 208,
}

export default LogoComponent
